const { default: Axios } = require("axios");

;(({ $, $$, log }) => {
    const voteForm =  $('.modal-vote-form')
    if (!voteForm) return

    const enabledEl = voteForm.querySelector('.modal-vote-form__enabled')
    const disabledEl = voteForm.querySelector('.modal-vote-form__disabled')
    const voteButton = voteForm.querySelector('.modal-vote-form__vote-button')

    // input
    const serverNameEl = document.querySelector("#vote-server-name")
    const serverIdInput = document.querySelector("#vote-server-id")

    if (!enabledEl || !disabledEl) return

    const countdown = voteForm.querySelector('.ro-countdown')
    if (!countdown) return

    const countDownTextEl = voteForm.querySelector('.modal-vote-form__cooldown-text')

    const timer = new RO.classes.Countdown({
        el: countdown,
        onStart: updateModalContent,
        onTick: updateModalContent
    })

    let initialVoteModalInfoLoading = false
    const modalVoteOpenTriggers = $$('.modal-vote-open-trigger')

    modalVoteOpenTriggers.forEach(trigger => {
        const serverName = trigger.dataset.serverName
        const serverId = trigger.dataset.serverId
        const API = trigger.dataset.api

        trigger.addEventListener('click', async () => {

            if (initialVoteModalInfoLoading) {
                return
            }

            initialVoteModalInfoLoading = true

            if (serverNameEl) {
                serverNameEl.innerHTML = serverName
            }

            if (serverIdInput) {
                serverIdInput.value = serverId
            }

            timer.stop()

            try {
                const response = await Axios.get(API, {
                    params: {
                        server_id: serverId
                    }
                })

                console.log('open response: ', response)

                if (response.status == 200) {
                    const { seconds } = response.data
                    timer.start(seconds)
                    CNS.$fns.openVoteModal(trigger)
                }

            } catch (error) {
                console.log(error.response)
            } finally {
                initialVoteModalInfoLoading = false
            }
        })
    })

    let isVoting = false
    voteButton.addEventListener('click', async e => {
        e.preventDefault()

        if (voteButton.classList.contains('button--disabled')) {
            return
        }

        if (isVoting) {
            return
        }

        const API = voteButton.dataset.api
        const serverId = serverIdInput.value

        isVoting = true

        voteButton.classList.add('button--disabled')

        try {
            const response = await Axios.post(API, {
                server_id : serverId
            })

            if (response.status == 200) {
                CNS.$fns.closeVoteModal()
                CNS.$fns.openVoteDoneModal()
            }
        } catch (error) {
            voteButton.classList.remove('button--disabled')
            console.log(error.response)
        } finally {
            isVoting = false
        }
    })


    function updateModalContent(result) {
        if (result.remainingSeconds > 0) {
            enabledEl.style.display = 'none'
            disabledEl.removeAttribute('style')
            voteButton.classList.add('button--disabled')
        } else {
            enabledEl.removeAttribute('style')
            disabledEl.style.display = 'none'
            voteButton.classList.remove('button--disabled')
        }

        countDownTextEl.innerHTML = result.formattedTime
    }
})(CNS);